import { BasePropertyApi } from './base-api.interface';
import { getFontWeight } from './get-common-properties';
import { updateFontWeight } from './update-common-properties';

export const fontWeightAPI: BasePropertyApi = {
  get: getFontWeight,
  update: updateFontWeight,
};
